import { DescriptionList, Text } from "@marekl/adminer/components";
import { formatDateTime } from "@marekl/adminer/format";
import {
  deadlineGroupLabel,
  deadlineGroups,
  type CompetitionDeadlineFields,
} from "../../lib/competitionDeadlines";

/**
 * A competition's uzávěrky for a club: the date first, then everything
 * that closes on it. One component for the Soutěže cards and the
 * competition's přihlášky page, so the two cannot tell a club different
 * things. See lib/competitionDeadlines for why rows merge by instant.
 */
export function CompetitionDeadlines({ competition }: { competition: CompetitionDeadlineFields }) {
  const groups = deadlineGroups(competition);
  if (groups.length === 0) {
    return <Text variant="muted">Uzávěrky nejsou nastavené.</Text>;
  }
  return (
    // Wide enough for „27. 12. 2026 23:59" on one line; the lib's 120px
    // default wraps it.
    <DescriptionList labelWidth="10.5rem">
      {groups.map((g) => {
        const label = deadlineGroupLabel(g.kinds);
        const date = formatDateTime(g.at);
        return (
          <DescriptionList.Item
            key={g.at.valueOf()}
            label={g.passed ? <Text variant="muted">{date}</Text> : date}
          >
            {g.passed ? (
              // In words as well as in grey, so it does not rest on colour.
              <Text variant="muted">{label} (proběhla)</Text>
            ) : (
              <>
                {label}
                {g.countdown && <Text variant="muted"> ({g.countdown})</Text>}
              </>
            )}
          </DescriptionList.Item>
        );
      })}
    </DescriptionList>
  );
}
